<template>
    <router-link :to="'/order-details/' + this.item._id">
        <div class="card my-6">
            <div class="card-content">
                <div class="columns is-tablet">
                    <div class="column">
                        <div class="columns cart-item__property-list">
                            <div class="column">
                                <div class="cart-item__property">
                                    <span class="property__label is-size-5"
                                        >Bestellnummer</span
                                    >
                                    <h3 class="property__value title is-4">
                                        {{ item.orderNumber }}
                                    </h3>
                                </div>
                                <div class="cart-item__property">
                                    <span class="property__label is-size-5"
                                        >Bestelldatum</span
                                    >
                                    <h3
                                        class="property__value title is-4 property--color"
                                    >
                                        {{ item.createdAt }}
                                    </h3>
                                </div>
                            </div>
                            <div class="column">
                                <div class="cart-item__property">
                                    <span class="property__label is-size-5"
                                        >Summe</span
                                    >
                                    <h3 class="property__value title is-4">
                                        {{
                                            item.amountTotal
                                                | toCents
                                                | currency
                                        }}
                                    </h3>
                                </div>
                                <div class="cart-item__property">
                                    <span class="property__label is-size-5"
                                        >Versandkosten</span
                                    >
                                    <h3 class="property__value title is-4">
                                        {{
                                            item.shippingCosts.calculatedTaxes
                                                .price
                                                | toCents
                                                | currency
                                        }}
                                    </h3>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div
                        class="column orders-list__status is-one-fifth-tablet has-background-primary-dark"
                    >
                        <div class="cart-item__property">
                            <span
                                class="property__label is-size-5 is-uppercase has-text-white"
                                >Status</span
                            >
                            <h3
                                class="property__value title is-4 has-text-white"
                            >
                                {{
                                    $t(
                                        `checkout.orderStatusLabels.${item.orderStatus}`
                                    )
                                }}
                            </h3>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </router-link>
</template>

<script>
export default {
    name: 'OrderListElement',
    props: ['item'],
    data() {
        return {
            time: '',
        };
    },
};
</script>

<style></style>
